import styled from "@emotion/styled";
import { Icon, Theme, Typography } from "@yuno/design-system-web";
import { useContext } from "react";
import item1 from "../../../../assets/styling/item1.svg";
import item2 from "../../../../assets/styling/item2.svg";
import item3 from "../../../../assets/styling/item3.svg";
import powered from "../../../../assets/styling/yuno.svg";
import poweredAlt from "../../../../assets/styling/yuno-alt.svg";
import { ThemeContext } from "../../../../context/theme-context";
import { CustomTheme } from "../../../../types/custom-theme";

const Container = styled.div`
  width: 350px;
  margin: 0 auto;
`;

const ItemContainer = styled.div<{ theme?: Theme }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;

  img {
    width: 48px;
    height: 48px;
    margin-right: 14px;
  }

  img.logo-y {
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }

  & .left-panel {
    display: flex;
    align-items: center;
  }

  & p {
    ${({ theme }) => theme.typography.small.regular};
  }
`;

const MainTitle = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => theme.typography.xl.bold};
  margin-bottom: 8px;
`;

const Subtitle = styled(Typography)<{
  theme?: Theme;
  customTheme: CustomTheme;
}>`
  ${({ theme }) => theme.typography.base.regular};
  color: ${({ customTheme }) =>
    customTheme.shopping_cart.description.font_color}!important;
  margin-bottom: 24px;
`;

const Card = styled.div<{ theme?: Theme; customTheme: CustomTheme }>`
  width: 473px;
  padding: 24px;
  padding-bottom: 0px;
  background: ${({ customTheme }) =>
    customTheme.shopping_cart.information.background_color};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  margin-bottom: 48px;
`;

const ResumeRow = styled.div<{ theme?: Theme; themeSelected: string }>`
  width: 473px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid
    ${({ theme, themeSelected }) =>
      themeSelected === "darkMode" ? "#6c6f75" : theme.palette.grey[2]};
  ${({ theme }) => theme.typography.small.regular};

  &.big {
    padding-top: 24px;
    border-bottom: none;
  }

  & p.big-font {
    ${({ theme }) => theme.typography.l.bold};
  }

  & p.alter-color {
    color: ${({ theme }) => theme.palette.grey[5]};
  }
`;

const CaretContainer = styled.div<{ theme?: Theme }>`
  display: flex;
  align-items: center;

  p {
    ${({ theme }) => theme.typography.tiny.bold};
    color: ${({ theme }) => theme.palette.grey[5]};
    margin-right: 8px;
  }
`;

const TermRow = styled.div<{ theme?: Theme; customTheme: CustomTheme }>`
  display: flex;
  width: 473px;
  align-items: center;
  justify-content: space-between;
  img {
    object-fit: cover;
    width: 146px;
    height: 20px;
  }

  .term-grid {
    display: flex;
    align-items: center;
    justify-content: end;
    color: ${({ customTheme }) =>
      customTheme.shopping_cart.description.font_color}!important;
    ${({ theme }) => theme.typography.base.regular};
  }

  p {
    color: ${({ customTheme }) =>
    customTheme.shopping_cart.description.font_color}!important;
    padding-left: 24px;
  }
`;

const ResumeContainer = styled.div`
  margin-bottom: 154px;
`;

export const ShoppingCart = () => {
  const { customTheme, themeSelected } = useContext(ThemeContext);

  return (
    <Container>
      <MainTitle>Review your order</MainTitle>
      <Subtitle customTheme={customTheme}>
        View your order details and finalize the order.
      </Subtitle>
      <Card customTheme={customTheme}>
        <ItemContainer>
          <div className="left-panel">
            <img src={item2} className="logo-y" />
            <Typography>Universal Store</Typography>
          </div>
          <CaretContainer>
            <Typography>Hidden items</Typography>
            <Icon name="CaretUp" size="9px" />
          </CaretContainer>
        </ItemContainer>
        <ItemContainer>
          <div className="left-panel">
            <img src={item1} />
            <Typography>Yuno AirPods</Typography>
          </div>
          <Typography>$5,000 COP</Typography>
        </ItemContainer>

        <ItemContainer>
          <div className="left-panel">
            <img src={item3} />
            <Typography>Yuno Laptop</Typography>
          </div>
          <Typography>$5,000 COP</Typography>
        </ItemContainer>
      </Card>

      <ResumeContainer>
        <ResumeRow themeSelected={themeSelected}>
          <Typography>Subtotal</Typography>
          <Typography>$10,000 COP</Typography>
        </ResumeRow>

        <ResumeRow themeSelected={themeSelected}>
          <Typography className="alter-color">Shipping Cost</Typography>
          <Typography className="alter-color">$500 COP</Typography>
        </ResumeRow>

        <ResumeRow className="big" themeSelected={themeSelected}>
          <Typography>Total due</Typography>
          <Typography className="big-font">$10,500 COP</Typography>
        </ResumeRow>
      </ResumeContainer>

      <TermRow customTheme={customTheme}>
        <img src={themeSelected === "darkMode" ? poweredAlt : powered} />
        <div className="term-grid">
          <Typography>Terms</Typography>
          <Typography>Privacy</Typography>
        </div>
      </TermRow>
    </Container>
  );
};
